import { axiosHttp } from "../helper/axiosHttp"


export const uploadAudiService=async(data)=>{
    
   const formdata = new FormData();
    formdata.append('audio',data.audio);
    formdata.append('audPurpose',data.audPurpose);
    return await axiosHttp.post('/audio',formdata).then((res)=>{
         console.log("audio section is",res)
         return res.data
     }).catch((err)=>{
         console.log("error data",err.response);
         return err.response.data;
     });
 }